const initialState = {
    profilePic: null
}

const profilePicturePageReducer = (state = initialState, action) => {
    switch (action.type) {
        case "fetchprofilepicpageseeker":
            state = { ...state, profilePic: action.payload };
            return state;
        default:
            return state;
    }
}

export default profilePicturePageReducer;